import React, { createContext, useCallback, useMemo, useRef } from 'react';

const PROJECT_IDS = [
  // LM
  'L&M Double Splash',
  'L&M Loft Sea Blue',
  'L&M Loft Blue',
  'L&M Loft Mix',
  'L&M Loft Green',
  'L&M Loft Purple',
  // PM
  'Novel Mix',
  'Novel Mix Summer',
  'Novel Blue',
  'Novel Silver',
  'Novel Purple',
  // BOND
  'Bond street premium blue',
  'Bond street premium silver',
  'Bond street premium mix',
  // MARLBORO
  'Marlboro touch',
  'Marlboro fine touch',
  // PARLIAMENT
  'Parliament soho compact blue',
  'Parliament soho compact silver',
  'Parliament soho vibe',
  // CHESTERFIELD
  '4 Silver',
  '6 Blue',
  'Retuned',
  // KV
  'KV',
  //GHWS
  'GHWS',
  'hstss1',
  'hstss2',
  'BND-B',
  'BND-R',
  'LM-B',
  'LM-R',
  'MLB-G',
  'MLB-R',
  'MLB-S',
  'Ches-O',
  'Ches-B',
  'Ches-SP',
  'Ches-SR',
  'MLB-T-LE',
  'MLB-F-T-LE',
  'KV2',
  'Ches-O-NB',
  'LM-SPL',
  'KV3',
  'KV4',
  'Ches-R',
  'PRL-A-LPE',
  'PRL-N-LPE',
  'PRL-P-LPE',
  'PRL-S-LPE',
  'PRL-A',
  'PRL-N',
  'PRL-S',
  'PRL-P',
  'PRL-A-SS',
  'PRL-S-SS',
  'Unsubscribe',
  'sms-prl',
  'sms-nonflv',
  'MLB-Ttn',
  'Ches-Prpl',
  'PRL-Sh-A-SSL',
  'PRL-Sh-S-SSL',
  'sms-mpm-25',
  'sms-prl-reg',
  '25-sms-prl-sh',
  '25UA-KV3',
  '25-sms-lm-loft',
  '25UA-KV4',
  '25-sms-che-ks',
  'MLB-Prpl',
  'sms-mrl-prpl',
  '25UA-KV5',
  'sms-mrl-ks',
  'sms-prl-crt',
  'LM-FC-R',
  'LM-FC-B',
  'sms-sp1',
  '25UA-LM-FC-R',
  '25UA-LM-FC-B',
  '25UA-KV6',
  '25UA-KV7',
  '25-sms-lm-fc',
  '25-sms-lm-100',
  '25-sms-che-prif',
  '25UA-MPM-B',
  '25UA-MPM-R',
  '24UA-MPM-PR',
  'ua-mlb',
  'ua-bnd',
  'ua-mpm',
  'ua-lm',
  'ua-ch',
  'ua-prl',
  'ua-kv',
  'sms-mrl-40',
  '26UA-PRL-A-L',
  '26UA-PRL-S-L',
  '24UA-PRL-A',
  '24UA-PRL-N',
  '24UA-PRL-P',
  '24UA-PRL-S',
  '26UA-LM-FC-B-100STD',
  '26UA-LM-FC-R-100STD',
  '26UA-LM-LFC-P-100',
  '26UA-LM-LFC-B-100',
  'PROMOTER',
  'sms-prl-line',
  'sms-prl-rvmp',
  'ua-hostess',
  'sms-prlm-s',
  '25-sms-lm-ssl',
  'sms-prlm-if',
  'PRL-Sh-A-SSL-new',
  'PRL-Sh-S-SSL-new',
  'Parliament soho compact blue new',
  'Parliament soho compact silver new',
  '26UA-PRL-Sign',
  'sms-lm-rvmp',
  'sms-soho-rvmp',
  '26UA-KV4',
  'sms-lm-40',
  'MGM-PersonalCabinet',
  '23UA-LM-4-test',
  '23UA-LM-6-test',
  '24UA-LM-L-Pr-test',
  '24UA-LM-Spl-test'
];

const EVENT_NAME = {
  // LM
  'L&M Double Splash': '',
  'L&M Loft Sea Blue': '',
  'L&M Loft Blue': '',
  'L&M Loft Mix': '',
  'L&M Loft Green': '',
  'L&M Loft Purple': '',
  // PM
  'Novel Mix': '',
  'Novel Mix Summer': '',
  'Novel Blue': '',
  'Novel Silver': '',
  'Novel Purple': '',
  // BOND
  'Bond street premium blue': '',
  'Bond street premium silver': '',
  'Bond street premium mix': '',
  // MARLBORO
  'Marlboro touch': '',
  'Marlboro fine touch': '',
  // PARLIAMENT
  'Parliament soho compact blue': '',
  'Parliament soho compact silver': '',
  'Parliament soho vibe': '',
  // CHESTERFIELD
  '4 Silver': '',
  '6 Blue': '',
  Retuned: '',
  // KV
  KV: '',
  // GHWS
  GHWS: '',
  // HSTSS
  hstss1: '',
  hstss2: '',
  'BND-B': '',
  'BND-R': '',
  'LM-B': '',
  'LM-R': '',
  'MLB-G': '',
  'MLB-R': '',
  'MLB-S': '',
  'Ches-O': '',
  'Ches-B': '',
  'Ches-SP': '',
  'Ches-SR': '',
  'LM-SP': '',
  'LM-SR': '',
  'MLB-T-LE': '',
  'MLB-F-T-LE': '',
  KV2: '',
  'Ches-O-NB': '',
  'LM-SPL': '',
  KV3: '',
  KV4: '',
  'Ches-R': '',
  'PRL-A': '',
  'PRL-A-LPE': '',
  'PRL-N-LPE': '',
  'PRL-P-LPE': '',
  'PRL-S-LPE': '',
  'PRL-N': '',
  'PRL-S': '',
  'PRL-P': '',
  'PRL-A-SS': '',
  'PRL-S-SS': '',
  Unsubscribe: '',
  'sms-prl': '',
  'sms-nonflv': '',
  'MLB-Ttn': '',
  'Ches-Prpl': '',
  'PRL-Sh-A-SSL': '',
  'PRL-Sh-S-SSL': '',
  'sms-mpm-25': '',
  'sms-prl-reg': '',
  '25-sms-prl-sh': '',
  '25UA-KV3': '',
  '25-sms-lm-loft': '',
  '25UA-KV4': '',
  '25-sms-che-ks': '',
  'MLB-Prpl': '',
  'sms-mrl-prpl': '',
  '25UA-KV5': '',
  'sms-mrl-ks': '',
  'sms-prl-crt': '',
  'LM-FC-R': '',
  'LM-FC-B': '',
  'sms-sp1': '',
  '25UA-LM-FC-R': '',
  '25UA-LM-FC-B': '',
  '25UA-KV6': '',
  '25UA-KV7': '',
  '25-sms-lm-fc': '',
  '25-sms-lm-100': '',
  '25-sms-che-prif': '',
  '25UA-MPM-B': '',
  '25UA-MPM-R': '',
  '24UA-MPM-PR': '',
  'ua-mlb': '',
  'ua-bnd': '',
  'ua-mpm': '',
  'ua-lm': '',
  'ua-ch': '',
  'ua-prl': '',
  'ua-kv': '',
  'sms-mrl-40': '',
  '26UA-PRL-A-L': '',
  '26UA-PRL-S-L': '',
  '24UA-PRL-A': '',
  '24UA-PRL-N': '',
  '24UA-PRL-P': '',
  '24UA-PRL-S': '',
  '26UA-LM-FC-B-100STD': '',
  '26UA-LM-FC-R-100STD': '',
  '26UA-LM-LFC-P-100': '',
  '26UA-LM-LFC-B-100': '',
  PROMOTER: '',
  'sms-prl-line': '',
  'sms-prl-rvmp': '',
  'ua-hostess': '',
  'sms-prlm-s': '',
  '25-sms-lm-ssl': '',
  'sms-prlm-if': '',
  'PRL-Sh-A-SSL-new': '',
  'PRL-Sh-S-SSL-new': '',
  'Parliament soho compact blue new': '',
  'Parliament soho compact silver new': '',
  '26UA-PRL-Sign': '',
  'sms-lm-rvmp': '',
  'sms-soho-rvmp': '',
  '26UA-KV4': '',
  'sms-lm-40': '',
  'MGM-PersonalCabinet': '',
  '23UA-LM-4-test': '',
  '23UA-LM-6-test': '',
  '24UA-LM-L-Pr-test': '',
  '24UA-LM-Spl-test': ''
};

export const DataLayerEventContext = createContext(undefined);

export function DataLayerEventProvider({ children }) {
  const isDevelopment = window.location.host.includes('localhost');
  const projectNameRef = useRef();
  projectNameRef.current = undefined;

  const projectGuard = useCallback((projectName) => {
    return PROJECT_IDS.find((it) => it === projectName);
  }, []);

  const init = useCallback((projectName) => {
    projectNameRef.current = projectName;
  }, []);

  const sendEvent = useCallback(
    (eventName) => {
      if (!projectGuard(projectNameRef.current)) return;
      if (!projectNameRef.current || !eventName) return;
      if (!window.dataLayer) return;

      const event = `${EVENT_NAME[projectNameRef.current]}${eventName}`;
      window.dataLayer.push({
        event,
        project_id: projectNameRef.current,
        month: new Date().toLocaleString('en-GB', { month: 'long' })
      });
    },
    [projectGuard, isDevelopment]
  );

  const providerValue = useMemo(() => {
    return {
      init,
      sendEvent
    };
  }, [init, sendEvent]);

  return (
    <DataLayerEventContext.Provider value={providerValue}>
      {children}
    </DataLayerEventContext.Provider>
  );
}
